const MAX_BODY_LENGTH = 60;

export type FormatMarkerNameInput = {
  authorName: string;
  body: string;
  replyCount: number;
  resolved: boolean;
};

/**
 * Formats a discussion into a Premiere marker name.
 * Includes reply count and resolved status for at-a-glance scanning.
 */
export function formatMarkerName({ authorName, body, replyCount, resolved }: FormatMarkerNameInput): string {
  const author = authorName || 'Discussion';

  let truncatedBody = body;

  if (body.length > MAX_BODY_LENGTH) {
    truncatedBody = body.slice(0, MAX_BODY_LENGTH) + '...';
  }

  let name = truncatedBody ? `${author}: ${truncatedBody}` : author;

  if (replyCount > 0) {
    name += ` (${replyCount} ${replyCount === 1 ? 'reply' : 'replies'})`;
  }

  if (resolved) {
    name = `[done] ${name}`;
  }

  return name;
}
